export class HttpError extends Error {
  readonly status: number;

  constructor(status: number, url: string) {
    super(`HTTP ${status} for ${url}`);
    this.name = 'HttpError';
    this.status = status;
  }
}

export const isAbortError = (err: unknown) => err instanceof DOMException && err.name === 'AbortError';
